/* YUUMA — Journal article index + product callout placement, customer address forms. Vanilla, no deps. */
(function () {
  'use strict';
  if (window.__yuumaJournal) return;
  window.__yuumaJournal = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Article: "In this story" index ---------- */
  var STOP = /^(a|an|the|of|to|and|for|with|your|our|in|on|at|is|are|how|why|what|when|you|my)$/i;
  function slugify(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48); }
  function shortLabel(t) {
    var w = t.replace(/^\s*(step\s*)?\d+[.):\-\s]+/i, '').split(/[:?!.–—]/)[0].replace(/[^\w\s'&-]/g, '').trim().split(/\s+/).filter(Boolean);
    while (w.length > 1 && STOP.test(w[0])) w.shift();
    w = w.slice(0, 2);
    while (w.length > 1 && STOP.test(w[w.length - 1])) w.pop();
    var out = w.join(' ');
    return out.charAt(0).toUpperCase() + out.slice(1);
  }
  function initArticle(body) {
    if (body.__jart) return; body.__jart = true;
    var heads = Array.prototype.filter.call(body.querySelectorAll('h2'), function (h) { return h.textContent.trim().length > 0 && h.textContent.trim().length <= 80; });

    // Product callout: place before the middle heading, as in the design.
    var callout = body.parentNode.querySelector('[data-jart-callout]');
    if (callout) {
      var blocks = Array.prototype.slice.call(body.children);
      var hIdx = heads.map(function (h) { return blocks.indexOf(h); }).filter(function (i) { return i > 0; });
      var at = hIdx.length > 1 ? hIdx[Math.floor(hIdx.length / 2)] : Math.min(4, blocks.length);
      if (blocks[at]) body.insertBefore(callout, blocks[at]); else body.appendChild(callout);
    }

    var toc = document.querySelector('[data-jart-toc]');
    var links = toc && toc.querySelector('[data-jart-toc-links]');
    if (!toc || !links || heads.length < 2) return;
    var used = {};
    heads.slice(0, 7).forEach(function (h) {
      if (!h.id) { var id = slugify(h.textContent) || 'section'; while (used[id] || document.getElementById(id)) id += '-2'; h.id = id; }
      used[h.id] = true;
      var a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = shortLabel(h.textContent.trim());
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + h.id);
      });
      links.appendChild(a);
    });
    toc.hidden = false;
    if ('IntersectionObserver' in window) {
      var anchors = links.querySelectorAll('a');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          Array.prototype.forEach.call(anchors, function (a) { a.setAttribute('aria-current', a.getAttribute('href') === '#' + e.target.id ? 'true' : 'false'); });
        });
      }, { rootMargin: '0px 0px -70% 0px' });
      heads.slice(0, 7).forEach(function (h) { io.observe(h); });
    }
  }

  /* ---------- Addresses: open / close forms, delete confirm, country -> province ---------- */
  function initAddresses(root) {
    if (root.__acct) return; root.__acct = true;
    function panels() { return root.querySelectorAll('[data-acct-panel]'); }
    function setOpen(key, open) {
      Array.prototype.forEach.call(panels(), function (p) { p.hidden = !(open && p.getAttribute('data-acct-panel') === String(key)); });
      Array.prototype.forEach.call(root.querySelectorAll('[data-acct-open]'), function (b) { b.setAttribute('aria-expanded', open && b.getAttribute('data-acct-open') === String(key) ? 'true' : 'false'); });
      if (open) {
        var p = root.querySelector('[data-acct-panel="' + key + '"]');
        if (p) { p.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' }); var f = p.querySelector('input:not([type=hidden])'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, reduceMotion ? 0 : 350); }
      }
    }
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-acct-open]');
      if (o) { e.preventDefault(); setOpen(o.getAttribute('data-acct-open'), o.getAttribute('aria-expanded') !== 'true'); return; }
      var c = e.target.closest('[data-acct-close]');
      if (c) { e.preventDefault(); var key = c.getAttribute('data-acct-close'); setOpen(key, false); var opener = root.querySelector('[data-acct-open="' + key + '"]'); if (opener) opener.focus(); }
    });
    root.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-acct-confirm]');
      if (f && !window.confirm(f.getAttribute('data-acct-confirm'))) e.preventDefault();
    });
    var S = window.Shopify;
    Array.prototype.forEach.call(root.querySelectorAll('[data-acct-country]'), function (sel) {
      var key = sel.getAttribute('data-acct-country');
      if (S && S.CountryProvinceSelector) {
        try { new S.CountryProvinceSelector('AddressCountry-' + key, 'AddressProvince-' + key, { hideElement: 'AddressProvinceWrap-' + key }); } catch (err) { /* noop */ }
      }
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-jart-body]'), initArticle);
    Array.prototype.forEach.call(document.querySelectorAll('[data-acct-addresses]'), initAddresses);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
